import React from "react"
import styled from "styled-components"
import DesignTokens from "./designTokens"
import { Heading } from "./typography"
import titleBorder from "../images/title-border.svg"
import RichContentTextBlock from "./richContentTextBlock"
import Img from "gatsby-image"
import { Box, Container, Flex, Grid } from "@theme-ui/components"
import { getPagePath } from "./pathUtils"
import { Link } from "gatsby"

const ImageBlockLegacy = ({
  title,
  image,
  text,
  alignment,
  negativeMarginTop,
  link,
}) => {
  return (
    <Box sx={{ marginTop: [0, 0, negativeMarginTop === false ? 0 : "-48px"] }}>
      <Container sx={{ py: [0, 0, 0] }}>
        <Grid columns={[1, 1, 2]} gap={0}>
          <Box
            sx={{
              order: alignment ? [2] : [2, 2, 1],
              ".gatsby-image-wrapper": { height: "100%" },
              marginRight: alignment ? ["none", "none", "none"] : "none",
              marginLeft: alignment ? "none" : ["none", "none", "none"],
            }}
          >
            <Img fluid={image.fluid} />
          </Box>
          <Flex
            sx={{
              my: [0, 0, 5],
              padding: [4, 4, 5],
              backgroundColor: "primary",
              order: alignment ? [1] : [1, 1, 2],
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {title && (
              <CustomHeading color={DesignTokens.colors.white}>
                {title}
              </CustomHeading>
            )}
            <RichContentTextBlock
              color={DesignTokens.colors.white}
              html={text}
            />
            {link && (
              <Box sx={{ mt: [3, 4, 5, 5] }}>
                <StyledLink to={getPagePath(link.page, link.locale)}>
                  {link.name}
                </StyledLink>
              </Box>
            )}
          </Flex>
        </Grid>
      </Container>
    </Box>
  )
}

const StyledLink = styled(Link)`
  color: white;
  text-transform: uppercase;
  text-decoration: none;
  padding-left: 3rem;
  background-image: linear-gradient(90deg, #ffffff, #ffffff);
  background-size: 36px 1px;
  background-position: 0 50%;
  background-repeat: no-repeat;
`

const CustomHeading = styled(Heading)`
  padding-bottom: 2rem;
  background-image: url(${titleBorder});
  background-repeat: no-repeat;
  background-position: bottom left;
  margin-bottom: 2rem;
`

export default ImageBlockLegacy
